import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { FaTimes, FaEdit, FaLink } from 'react-icons/fa';
import FormReceiveAddress from './FormReceiveAddress';
import { GET_MANY_USER_ADDRESS_USER_ID, GET_USER_ADDRESS_BY_PHONE } from '../../../../graphql/userConfirm/userAddress/query';
import { useLazyQuery } from '@apollo/client';
import _ from 'lodash';
import './ListReceiveAddress.css';
import DeleteReceiveAddress from './DeleteReceiveAddress';
import { GET_SETTING_BY_SHOP } from '../../../../graphql/setting/query';
import { HAL_KEY, JNT_KEY, MIXAY_KEY } from '../../../../constants';
import { convertLogicticsName, formatDeliveryAddress } from '../../../../helpers';
import AddressSheet from '../../../orders/OrderConfirm/AddressSheet';
import { GET_MIXAY_DEFAULT_DSE } from '../../../../graphql/shop/shopAddress/query';
// import UpdateReceiveAddress from './UpdateReceiveAddress';

const ListReceiveAddress = ({ userId, idSelect, setIdSelect, userConfirm, psid, onClose, setIsDataSelect, setIsSelect, orderGroup, selectedDelivery, onUseManualAddress }) => {
    // useState
    const [editData, setEditData] = useState({});

    // GET USER
    const [userAddressUserId_API, { data: userAddressUserId_DATA, loading: userAddressUserIdLoading }] = useLazyQuery(GET_MANY_USER_ADDRESS_USER_ID, { fetchPolicy: "cache-and-network" });
    const [userAddressByPhone_API, { data: userAddressByPhone_DATA, loading: userAddressByPhoneLoading }] = useLazyQuery(GET_USER_ADDRESS_BY_PHONE, { fetchPolicy: "network-only" });
    const [getMixayDefaultDSE_API, { data: getMixayDefaultDSE_DATA }] = useLazyQuery(GET_MIXAY_DEFAULT_DSE, { fetchPolicy: "cache-first" });
    const [settingByShopId_API, { data: settingByShopId_DATA }] = useLazyQuery(GET_SETTING_BY_SHOP, { fetchPolicy: "cache-first" });
    useEffect(() => {
        if (userId || userConfirm?.phone) {
            fetchUserAddressUserId_API();
            fetchSettingByShopId_API();
            getMixayDefaultDSE_API({
                variables: {
                    where: {
                        shop: orderGroup?.shop?.id
                    },
                },
            });
        }
    }, [userId, userConfirm?.phone]);

    const isMixayDefaultDSE = useMemo(() => {
        if (getMixayDefaultDSE_DATA) {
            const response = JSON.parse(getMixayDefaultDSE_DATA?.getMixayDefaultDSE);
            return response?.data?.dropship_end;
        }
    }, [getMixayDefaultDSE_DATA]);

    const fetchSettingByShopId_API = async () => {
        try {
            // get shop in local storage
            const shopId = orderGroup?.shop?.id;
            await settingByShopId_API({
                variables: {
                    where: {
                        shop: shopId
                    },
                },
            });
        } catch (err) {
            console.log("ERROR_fetchSettingByShopId_API")
        }
    };

    const [isReceive, setIsReceive] = useState([]);
    useEffect(() => {
        const addressList = userAddressByPhone_DATA?.userAddressByPhone?.data
            ?? userAddressUserId_DATA?.userAddressUserId?.data;
        if (addressList) {
            // ลูกค้าเลือกขนส่งมาแล้ว ให้เหลือเฉพาะที่อยู่ของเจ้านั้น ไม่ได้เลือกก็แสดงทั้งหมดเหมือนเดิม
            const _data = _.isEmpty(selectedDelivery)
                ? addressList
                : addressList.filter((item) => item?.deliveryName === selectedDelivery);

            const newIsReceive = _data.map((item) => {
                return { ...item, isSelected: idSelect === item?.id ? true : false }
            });
            setIsReceive(newIsReceive);
        }
    }, [userAddressUserId_DATA, userAddressByPhone_DATA, selectedDelivery]);


    // * ADD USER-RECEIVE ADDRESS
    const [isAddModal, setIsAddModal] = useState(false);
    const onCloseModalAdd = () => {
        setIsAddModal(false);
        setEditData({});
    };

    // * DELETE USER-RECEIVE ADDRESS
    const [isDeleteReceiveModal, setIsDeleteReceiveModal] = useState(false);
    const [isDeleteReceiveData, setIsDeleteReceiveData] = useState({});
    const onCloseDeleteReceiveModal = () => {
        setIsDeleteReceiveModal(false);
        fetchUserAddressUserId_API();
    };

    // * UPDATE USER-RECEIVE ADDRESS
    // const [isUpdateReceiveModal, setIsUpdateReceiveModal] = useState(false);
    // const [isUpdateReceiveData, setIsUpdateReceiveData] = useState({});
    // const onCloseUpdateReceiveModal = () => {
    //     setIsUpdateReceiveModal(false);
    //     fetchUserAddressUserId_API();
    // };
    // const handleSelectDefault = (id) => {
    //     setIsReceive(isReceive.map(receive => ({ ...receive, default: receive?.id === id })));
    // };
    // const handleEdit = ({value}) => {
    //     setIsUpdateReceiveData({value});
    //     setIsUpdateReceiveModal(true);
    // };

    const fetchUserAddressUserId_API = async () => {
        try {
            if(userAddressUserIdLoading || userAddressByPhoneLoading) return;
            // ໜ້າ order-confirm ຄົ້ນດ້ວຍເບີໂທ ຈຶ່ງເຫັນປະຫວັດຄົບ ລວມທີ່ຢູ່ເກົ່າທີ່ຜູກກັບບັນຊີອື່ນ
            if (userConfirm?.phone) {
                await userAddressByPhone_API({
                    variables: {
                        where: {
                            userTel: userConfirm?.phone
                        },
                    },
                });
                return;
            }
            await userAddressUserId_API({
                variables: {
                    where: {
                        user: userId
                    },
                },
            });
        } catch (err) {
            console.log("ERROR_fetchUserAddressUserId_API", err)
        }
    }

    const handleSelect = ({ value, id }) => {
        if (value?.deliveryName === "OF_POINT") {
            const newSetting = settingByShopId_DATA?.settingByShopId;
            const sender = {
                fullName: newSetting?.shop?.name,
                tel: newSetting?.shop?.phone,
                province: newSetting?.shop?.address?.province,
                district: newSetting?.shop?.address?.district,
                village: newSetting?.shop?.address?.village,
                branch: newSetting?.shop?.address?.village
            }
            setIsReceive(isReceive.map(receive => ({ ...receive, isSelected: receive?.id === id })));
            setIsDataSelect({ ...value, sender, latLong: newSetting?.latLong });
        } else {
            setIsReceive(isReceive.map(receive => ({ ...receive, isSelected: receive?.id === id })));
            setIsDataSelect(value);
        }
        setIdSelect(id);
        setIsSelect(true);
    };

    const handleDelete = ({ value }) => {
        setIsDeleteReceiveData({ value });
        setIsDeleteReceiveModal(true);
    };

    //TODO MIXAY...
    const handleEdit = ({ value }) => {
        console.log("edit data", value);
        setEditData(value);
        setIsAddModal(true);
    };

    const newAddress = (value) => formatDeliveryAddress(value) || "ບໍ່ພົບຂໍ້ມູນທີ່ຢູ່";
    const handleDisableRow = (key, data) => {
        switch (key) {
            case MIXAY_KEY:
                return data?.mxIsOpen ? false : true;
            case "OF_POINT":
                return data?.deliveryOfPoint ? false : true;
            case HAL_KEY:
                return data?.halIsOpen ? false : true;
            case JNT_KEY:
                return data?.jntIsOpen ? false : true;
            default:
                return false;
        }
    }

    // ຂຶ້ນ loading ສະເພາະຕອນໂຫຼດຢູ່ແທ້ໆ
    //
    // ເມື່ອກ່ອນເຊັກແຕ່ `_.isEmpty(isReceive)` ເຊິ່ງແຍກ 2 ສະຖານະນີ້ບໍ່ອອກ:
    //   ກຳລັງໂຫຼດ  ↔  ໂຫຼດແລ້ວແຕ່ບໍ່ມີທີ່ຢູ່ຂອງຂົນສົ່ງທີ່ເລືອກ
    // ພໍລູກຄ້າສະຫຼັບ dropdown ໄປເຈົ້າທີ່ຍັງບໍ່ເຄີຍສ້າງທີ່ຢູ່ ກອງແລ້ວເຫຼືອ 0 ລາຍການ
    // → ໜ້າຈໍຄ້າງທີ່ "Is loading..." ຕະຫຼອດ ໄປຕໍ່ບໍ່ໄດ້
    //
    // ແລະ early return ນີ້ຢູ່ກ່ອນ modal "ສ້າງໃໝ່" ຈຶ່ງເອົາ empty state ໄວ້ໃນ return ຫຼັກ
    // ບໍ່ແມ່ນບ່ອນນີ້ ບໍ່ງັ້ນກົດປຸ່ມແລ້ວ modal ບໍ່ຂຶ້ນ
    // ຕ້ອງກວດ loading ຂອງທັງສອງ query — ໜ້າ order-confirm ຄົ້ນດ້ວຍເບີໂທ
    // ຖ້າກວດແຕ່ຕົວ userId ລູກຄ້າຈະເຫັນຈໍວ່າງໆລະຫວ່າງລໍຖ້າ ນຶກວ່າບໍ່ມີທີ່ຢູ່
    if ((userAddressUserIdLoading || userAddressByPhoneLoading) && _.isEmpty(isReceive)) {
        return (
            <div className="cf-loading">
                <Spinner animation="border" size="sm" />
                <span>ກຳລັງໂຫຼດທີ່ຢູ່...</span>
            </div>
        );
    }

    return (
        <div>
           
            {/* ໂຫຼດແລ້ວແຕ່ບໍ່ມີທີ່ຢູ່ຂອງຂົນສົ່ງທີ່ເລືອກ — ບອກໃຫ້ຊັດ ແລ້ວຊີ້ໄປປຸ່ມ "ສ້າງໃໝ່" ຂ້າງລຸ່ມ */}
            {_.isEmpty(isReceive) && (
                <div className="text-center py-4">
                    <p className="fw-bold mb-1" style={{ color: '#dc3545' }}>ຍັງບໍ່ມີທີ່ຢູ່ສຳລັບຂົນສົ່ງນີ້</p>
                    <p className="mb-0" style={{ fontSize: 13, opacity: 0.7 }}>ກົດປຸ່ມ "+ ເພີ່ມທີ່ຢູ່ໃໝ່" ຂ້າງລຸ່ມ</p>
                </div>
            )}

            {!_.isEmpty(isReceive) && (
            <div className="cf-items">
                {isReceive.map((receive) => {
                    const isOfPoint = receive?.deliveryName === "OF_POINT";
                    // ຮັບເຄື່ອງໜ້າຮ້ານສະແດງສະເພາະຮ້ານທີ່ເປີດຕົວເລືອກນີ້ໄວ້
                    if (isOfPoint && !settingByShopId_DATA?.settingByShopId?.deliveryOfPoint) return null;
                    const isRowDisabled =
                        (!isMixayDefaultDSE && receive?.deliveryName === MIXAY_KEY)
                        || handleDisableRow(receive?.deliveryName, settingByShopId_DATA?.settingByShopId);
                    return (
                        <div
                            key={receive?.id}
                            className={`cf-addr${receive?.isSelected ? " cf-addr--selected" : ""}${isRowDisabled ? " cf-addr--disabled" : ""}`}
                        >
                            {/* label ຫຸ້ມທັງແຖວ ກົດບ່ອນໃດກໍ່ເລືອກໄດ້ — radio ເພາະເລືອກໄດ້ອັນດຽວ */}
                            <label className="cf-addr__pick">
                                <input
                                    type="radio"
                                    name="cf-saved-address"
                                    className="cf-addr__input"
                                    checked={!!receive?.isSelected}
                                    disabled={isRowDisabled}
                                    onChange={() => handleSelect({ value: receive, id: receive?.id })}
                                />
                                {!isOfPoint && (
                                    <img className="cf-addr__logo" src={receive?.img || undefined} alt="" />
                                )}
                                <span className="cf-addr__text">
                                    <span className="cf-addr__name">
                                        {isOfPoint
                                            ? `ຮັບເຄື່ອງໜ້າຮ້ານ (${settingByShopId_DATA?.settingByShopId?.shop?.name})`
                                            : convertLogicticsName(receive?.deliveryName)}
                                    </span>
                                    <span className="cf-addr__meta">
                                        {receive?.userName} · {receive?.userTel}
                                    </span>
                                    {!isOfPoint && (
                                        <span className="cf-addr__meta">{newAddress(receive)}</span>
                                    )}
                                </span>
                            </label>

                            <div className="cf-addr__actions">
                                {isOfPoint ? (
                                    settingByShopId_DATA?.settingByShopId?.latLong && (
                                        <a
                                            className="cf-icon-btn"
                                            href={settingByShopId_DATA?.settingByShopId?.latLong}
                                            target="google_map"
                                            rel="noreferrer"
                                            aria-label="ເປີດແຜນທີ່ຮ້ານ"
                                        >
                                            <FaLink aria-hidden="true" />
                                        </a>
                                    )
                                ) : (
                                    <>
                                        <button
                                            type="button"
                                            className="cf-icon-btn"
                                            onClick={() => handleEdit({ value: receive })}
                                            aria-label="ແກ້ໄຂທີ່ຢູ່ນີ້"
                                        >
                                            <FaEdit aria-hidden="true" />
                                        </button>
                                        <button
                                            type="button"
                                            className="cf-icon-btn cf-icon-btn--danger"
                                            onClick={() => handleDelete({ value: receive })}
                                            aria-label="ລຶບທີ່ຢູ່ນີ້"
                                        >
                                            <FaTimes aria-hidden="true" />
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            )}

            {/* ຄຳອະທິບາຍ 3 ແຖວເກົ່າຖືກຫຍໍ້ — ໄອຄອນແຕ່ລະອັນມີ aria-label ບອກໜ້າທີ່ຢູ່ແລ້ວ */}
            {!_.isEmpty(isReceive) && (
                <div className="cf-field__helper" style={{ textAlign: 'center' }}>
                    ເລືອກທີ່ຢູ່ແລ້ວກົດ "ໃຊ້ທີ່ຢູ່ນີ້"
                </div>
            )}

            <div className="cf-actions">
                {/* ບໍ່ມີທີ່ຢູ່ໃຫ້ໃຊ້ ຈຶ່ງບໍ່ຕ້ອງມີປຸ່ມ "ໃຊ້ທີ່ຢູ່ນີ້" —
                    ຂອງເກົ່າສະແດງເປັນປຸ່ມຫຼັກສີເຂັ້ມທັ້ງໆທີ່ບໍ່ມີຫຍັງໃຫ້ເລືອກ ແລ້ວກົດແລ້ວປິດໜ້າໄປເສີຍໆ */}
                {!_.isEmpty(isReceive) && (
                    <button
                        type="button"
                        className="cf-btn cf-btn--primary"
                        onClick={() => onClose()}
                    >
                        ໃຊ້ທີ່ຢູ່ນີ້
                    </button>
                )}
                <button
                    type="button"
                    className={`cf-btn ${_.isEmpty(isReceive) ? 'cf-btn--primary' : 'cf-btn--secondary'}`}
                    onClick={() => setIsAddModal(true)}
                >
                    + ເພີ່ມທີ່ຢູ່ໃໝ່
                </button>
            </div>

            {/* pattern ດຽວກັບ "ເພີ່ມທີ່ຢູ່ຂົນສົ່ງ" ຢູ່ໜ້າ checkout */}
            <AddressSheet
                open={isAddModal}
                title={editData?.id ? "ແກ້ໄຂທີ່ຢູ່ຈັດສົ່ງ" : "ເພີ່ມທີ່ຢູ່ຂົນສົ່ງ"}
                onClose={onCloseModalAdd}
            >
                <div className="cf-card">
                    <FormReceiveAddress
                        userConfirm={userConfirm} psid={psid} onCloseModalAdd={onCloseModalAdd} fetchUserAddressData={fetchUserAddressUserId_API} orderData={orderGroup}
                        editData={editData} setEditData={setEditData}
                        selectedDelivery={selectedDelivery}
                        // ປິດຟອມນີ້ກ່ອນ ແລ້ວສົ່ງຕໍ່ຂຶ້ນໄປໃຫ້ຊັ້ນເທິງປິດ sheet ຂອງມັນ
                        onUseManualAddress={onUseManualAddress ? () => {
                            onCloseModalAdd();
                            onUseManualAddress();
                        } : undefined}
                    />
                </div>
            </AddressSheet>


            {/* //TODO Delete Modal */}
            {/* ຫົວຂໍ້ຢູ່ໃນ component ເອງ ຈຶ່ງບໍ່ໃຊ້ Modal.Header
                onHide ໃຫ້ກົດພື້ນຫຼັງ ຫຼື Escape ປິດໄດ້ — ທາງອອກທີ່ປອດໄພ */}
            <Modal
                centered
                show={isDeleteReceiveModal}
                onHide={() => setIsDeleteReceiveModal(false)}
                contentClassName="cf-dialog"
            >
                <Modal.Body className="p-0">
                    <DeleteReceiveAddress
                        userAddress={isDeleteReceiveData} onClose={onCloseDeleteReceiveModal} setDeleteReceiveModal={setIsDeleteReceiveModal}
                    />
                </Modal.Body>
            </Modal>

            {/* //TODO Update Modal */}
            {/* <Modal centered show={isUpdateReceiveModal}
            className="info"
            onHide={() => {setIsUpdateReceiveModal(false)}}
        >
            <Modal.Header>
                <Modal.Title>ແກ້ໄຂ້ທີ່ຢູ່ສຳລັບການຈັດສົ່ງ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <UpdateReceiveAddress 
                    userAddress={isUpdateReceiveData} onClose={onCloseUpdateReceiveModal} setUpdateReceiveModal={setIsUpdateReceiveModal}
                />
            </Modal.Body> 
        </Modal> */}

        </div>
    );
};

export default ListReceiveAddress;